import { useEffect } from 'react';
import { JWebPromise, WhenJWebReady } from '@jarvis/jweb-core';
import { ProgressIndicator } from '@veneer/core';
import { useHistory } from 'react-router-dom';
import { usePhotobookApiWebHttpClient } from '../../helpers/useJarvisApiWebHttpClient';
import { PhotobookApi } from '../../helpers/apis/photobookApi';
import { LocalStorageHelper } from '../../helpers/localStorage';

declare global {
  interface Window {
    cleanUpMediaclip: () => void;
  }
}

const AddToCartPage = () => {
  const photobookApi = new PhotobookApi(usePhotobookApiWebHttpClient());

  useEffect(() => {
    console.log('useEffect...');
    WhenJWebReady.then((_res: JWebPromise) => {
      console.log('JwebReady.');
      addToCartAndMoveToCart(_res);
    });
  }, []);

  const history = useHistory();

  const addToCartAndMoveToCart = async (jweb: JWebPromise) => {
    try {
      const projectId = LocalStorageHelper.getProjectId();
      console.log('Using projectId from localstorage ' + projectId);
      if (projectId != undefined) {
        console.log('Getting project photos');
        const response = await photobookApi.internalGetProjectPhotos(projectId);

        console.log(response.data.photoUrns);

        const filesToUpload: unknown[] = [];
        response.data.photoUrns.forEach((photoUrn: string) => filesToUpload.push({ filename: photoUrn }));
        console.log('Files to upload:', filesToUpload);

        const onAddToCartPayload = { projectName: projectId, projectPhotos: filesToUpload };
        console.log('Cart payload:', onAddToCartPayload);
        jweb.Plugins.MCDesigner?.onAddToCart(onAddToCartPayload);
      }

      console.log('About to call Add to cart...');

      await photobookApi.internalAddToCart();

      console.log('Add to cart in the backend is done.');
      history.push('/cart');
    } catch (error) {
      console.log('Add to cart in the backend could NOT be done.');
      console.log(error);
    }
  };

  return (
    <div className="spinner">
      <ProgressIndicator />
    </div>
  );
};

export default AddToCartPage;
